import script from "./InternalStorePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalStorePopup.vue?vue&type=script&setup=true&lang=ts"

import "./InternalStorePopup.vue?vue&type=style&index=0&id=316ed70d&lang=css"

const __exports__ = script;

export default __exports__